// extracted by mini-css-extract-plugin
export default {"upload-templates__modal-header":"UploadTemplatesButton_upload-templates__modal-header__JWasg"};